import { useTranslate } from "@similarweb/i18n-provider";
import { TextCell } from "@similarweb/pro-logic-components";
import { AvatarName, AvatarNameCounter, AvatarNameGroup } from "@similarweb/ui-components";

import { buildAvatarNamePreview } from "app/pages/sales-intelligence/domain/teams/utils/buildAvatarNamePreview";

import type { TeamListItem } from "../../types/teams.types";

type TeamsTableMembersCellProps = {
    team: TeamListItem;
};

export const TeamsTableMembersCell = ({ team }: TeamsTableMembersCellProps) => {
    const { translate } = useTranslate();

    const memberCount = team.membersCount;
    const namedMembers = (team.previewMembers ?? []).filter((member): member is { userId: number; name: string } =>
        Boolean(member.name?.trim()),
    );
    const extraMembersCount = Math.max(memberCount - namedMembers.length, 0);
    const moreLabel =
        extraMembersCount > 0
            ? translate("si.management.teams.detail.members_preview.more", { count: extraMembersCount })
            : null;
    const { firstName, remainingNames } = buildAvatarNamePreview(
        namedMembers.map((member) => member.name),
        memberCount,
        moreLabel,
    );

    if (firstName === undefined) {
        return <TextCell>-</TextCell>;
    }

    return (
        <AvatarNameGroup data-automation={`teams-table-members-${team.teamId}`}>
            <AvatarName name={firstName} />
            <AvatarNameCounter names={remainingNames} />
        </AvatarNameGroup>
    );
};
